export default defineNuxtPlugin(() => {
  const originalAppendChild = document.head.appendChild.bind(document.head)
  const originalInsertBefore = document.head.insertBefore.bind(document.head)

  document.head.appendChild = ((node: Node) => {
    if (
      node instanceof HTMLLinkElement &&
      (node.rel === 'modulepreload' || node.rel === 'prefetch')
    ) {
      return node
    }
    return originalAppendChild(node)
  }) as typeof document.head.appendChild

  document.head.insertBefore = ((node: Node, referenceNode: Node | null) => {
    if (
      node instanceof HTMLLinkElement &&
      (node.rel === 'modulepreload' || node.rel === 'prefetch')
    ) {
      return node
    }
    return originalInsertBefore(node, referenceNode)
  }) as typeof document.head.insertBefore
})
